/** Public site metadata only. Authored editorial metadata is never translated. */
export const pageDescriptions: Record<string, string> = {
  '/': 'Bybeit helps SaaS and AI companies enter Japan with market research, localization, and hands-on support.',
  '/about': 'Learn about Bybeit — the team bridging Japan and the world for SaaS & AI startups.',
  '/configurator': 'Configure a Japan market-entry plan and estimate one-time, monthly, and performance-based service costs.',
  '/company': 'Company information for Bybeit, Inc.',
  '/announcements': 'Electronic public notices issued by Bybeit, Inc.',
  '/status': 'Current service availability and incident updates for Bybeit.',
  '/terms': 'Terms of Service for Bybeit.',
  '/privacy': 'Privacy Policy for Bybeit.',
  '/blog': 'Ideas and practical perspectives on building, launching, and growing in Japan.',
  '/newsroom': 'Company updates and press releases from Bybeit, Inc.',
}
